import { createApp } from 'vue';
import { createPinia } from 'pinia'
import CierraChat from './components/WidgetElement.vue';
import Markdown from 'vue3-markdown-it';
import './style.css';
import './bootstrap.js';
import 'highlight.js/styles/monokai.css';

const widgetInstance = createApp(CierraChat, {
    lang: findConfigParam('lang', 'en'),
    color: findConfigParam('color', '#F35627'),
    secondaryColor: findConfigParam('secondaryColor', '#FFFEFD'),
    token: findConfigParam('token'), // Could be null if you have handling for that in your component
    botId: findConfigParam('botId'), // Could be null if you have handling for that in your component
})


const pinia = createPinia()

widgetInstance.use(pinia);
widgetInstance.use(Markdown);

const element = widgetInstance.mount(document.createElement('div'));

document.body.appendChild(element.$el);


// find the param, prefer the window object, then the url if not available. Alternatively return null
function findConfigParam(paramName, defaultParam = null) {
    const param = getParamFromWindowObject(paramName) ?? getParamFromUrl(paramName);
    if (param) {
        return param;
    }
    return defaultParam;
}

function getParamFromWindowObject(paramName) {
    if (window.CierraChatWidget && window.CierraChatWidget[paramName]) {
        return window.CierraChatWidget[paramName];
    }
    return null;
}

function getParamFromUrl(paramName) {
    const scriptUrl = new URL(document.currentScript.src);
    return scriptUrl.searchParams.get(paramName);
}